import { useState, useRef } from "react";
import { Play, Volume2, VolumeX } from "lucide-react";

const DEMO_VIDEO_URL = "https://ezniiqkbfgejpefpuvue.supabase.co/storage/v1/object/public/demo-videos/santa-demo";

export function VideoPreview() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlayClick = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <div 
      className="relative w-full h-48 bg-gradient-to-br from-primary/20 to-accent/20 rounded-lg overflow-hidden cursor-pointer group"
      onClick={handlePlayClick}
    >
      <video
        ref={videoRef}
        src={DEMO_VIDEO_URL}
        className="w-full h-full object-cover"
        loop
        muted={isMuted}
        playsInline
        onEnded={() => setIsPlaying(false)}
      >
        <track kind="captions" src="" label="No captions available" default />
      </video>

      {/* Play button overlay */}
      <div 
        className={`
          absolute inset-0 flex items-center justify-center bg-black/30
          transition-opacity duration-300
          ${isPlaying ? "opacity-0 group-hover:opacity-100" : "opacity-100"}
        `}
      >
        <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center shadow-lg hover:scale-110 transition-transform">
          <Play className="w-7 h-7 text-primary ml-1" fill="currentColor" />
        </div>
      </div>

      {/* Mute toggle */}
      <button
        onClick={toggleMute}
        className="absolute bottom-3 right-3 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors z-10"
        aria-label={isMuted ? "Unmute video" : "Mute video"}
      >
        {isMuted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
      </button>

      {/* Demo badge */}
      <div className="absolute top-3 left-3 text-xs font-medium bg-gold/90 text-primary-foreground px-2 py-1 rounded-full">
        Example Video
      </div>
    </div>
  );
}
